var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iphone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u4EA7\\u54C1-\\u8BD1\\u7B51\\u4E91",
    transform: "translate(-1837.000000, -677.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u670D\\u52A1\\u54A8\\u8BE2",
    transform: "translate(1834.000000, 670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-17",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-24",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1098255,10.971254 L11.2745658,12.7524578 C10.6635836,13.4296246 10.4020413,14.2839961 10.5331374,15.1361212 C11.3135961,18.7085313 13.1389797,21.9424785 15.770187,24.4617196 C18.4019448,26.9814877 21.7415208,28.7452464 25.273454,29.4626704 L25.4750622,29.4868787 C26.2793298,29.5557923 27.0536719,29.2912185 27.6563108,28.7488435 L29.412,27.045 L29.3318759,27.0921039 C29.4959022,27.0100908 29.6135688,26.9088268 29.7065628,26.7666249 L29.772021,26.6519588 C30.2175225,25.9906673 29.9475816,25.0336042 29.2232155,24.5506935 L25.4268244,22.1100738 L25.3227654,22.0490983 C25.0041642,21.8869216 24.6336231,21.9133023 24.3698157,22.1771097 L22.579,23.586 L22.8344237,23.6838292 C21.4442184,23.1873273 20.1463641,22.3352007 19.0138508,21.2026875 L18.738838,20.9319423 C17.8400838,20.0173187 17.1219383,18.9824707 16.6161002,17.8625359 L16.588,17.797 L18.0691354,16.0308174 C18.3325479,15.6410862 18.3325479,15.2161968 18.0394286,14.9230775 L15.6117102,11.2639956 L15.491827,11.1129843 L15.4069375,11.0215309 C15.377321,10.9932628 15.3460887,10.9671854 15.3123538,10.9432216 L15.282,10.926 L15.3327002,10.971254 C14.7043615,10.3429153 13.7381642,10.3429153 13.1098255,10.971254 Z",
    id: "\\u8DEF\\u5F84"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.96f7dc383f0a60911fb9b24567fb1b57.svg";
export { ForwardRef as ReactComponent };